import { render, staticRenderFns } from "./ReportsTableWithLazyLoading.vue?vue&type=template&id=e74aa776&scoped=true"
import script from "./ReportsTableWithLazyLoading.vue?vue&type=script&lang=js"
export * from "./ReportsTableWithLazyLoading.vue?vue&type=script&lang=js"
import style0 from "./ReportsTableWithLazyLoading.vue?vue&type=style&index=0&id=e74aa776&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74aa776",
  null
  
)

export default component.exports